const MESSAGES = {
	ACTION: {
		SAVED: 'Registro salvo com sucesso',
		SAVE_ERROR: 'Falha ao salvar o registro',
		EDITED: 'Registro atualizado com sucesso',
		EDIT_ERROR: 'Falha ao atualizar o registro',
		DELETED: 'Registro removido com sucesso',
		DELETE_ERROR: 'Falha ao remover o registro',
		DELETE_ID_ERROR: 'Identificador não encontrado',
		GET_ERROR: 'Falha ao recuperar dados',
        GENERALIZED_ERRORS: 'Ocorreram diversos erros. Informe o administrador do sistema',
	},
	VALIDATION: {
		REQUIRED_FIELD: 'Campo obrigatório',
		VALIDATION_ERROR: 'Falha na validação. Por favor, verifique os campos obrigatórios',
		PARAMETERS_ERROR_VALIDATION: 'Falha ao validar os parâmetros',
		ITEM_EXISTS: 'Item já inserido',
		EMPTY_COLLECTION: 'Falha na validação. Registros não encontrados',
		EMPTY_COLLECTION_TO_ADD: 'Falha na validação. Não há registros para adicionar',
		INVALID_STATUS: 'Situação inválida para essa ação',
        NOT_MATCHING_PASSWORD: 'As senhas não coincidem',
        INVALID_OTP: 'Código de segurança inválido',
		INVALID_FORMAT: 'Formato inválido'
	},
	SIGN: {
		VALIDATION_ERROR: 'Falha na validação. Por favor, verifique a assinatura',
		SUCCESS: 'Itens assinados com sucesso',
		NOT_FOUND: 'Assinatura não encontrada',
		NOT_FOUND_ITEMS: 'Não há itens para assinar'
	},
	WORK_ORDER_REPORT: {
		REQUESTED: 'Solicitação enviada. O relatório está sendo gerado e será enviado para o seu e-mail em instantes',
		REQUEST_ERROR: 'Não foi possível solicitar o relatório. Tente novamente em instantes',
		UNAUTHORIZED: 'Sua sessão expirou. Faça login novamente para solicitar o relatório',
		EMPTY_SELECTION: 'Não há ordens de serviço selecionadas',
		SINGLE_SELECTION_ONLY: 'Selecione apenas uma ordem de serviço para gerar o relatório',
		MAX_SELECTION: 'Quantidade máxima de OS selecionadas atingida',
		DIFFERENT_CREATOR: 'As ordens de serviço selecionadas devem ser do mesmo responsável',
		DIFFERENT_SERVICE_TYPE: 'As ordens de serviço selecionadas devem ser do mesmo serviço',
	},
	LOGIN: {
		CODE_SENDED: 'Código de acesso enviado para seu e-mail',
		ERROR: 'Falha ao realizar login. Por favor, entre em contato com o administrador do sistema',
		EMAIL_NOT_FOUN: 'Email não encontrado. Por favor, faça login novamente',
		VERIFICATION_CODE_SUCCESS: 'Código verificado com sucesso!',
		VERIFICATION_CODE_ERROR: 'Erro ao verificar código de autenticação.',
		EMPLOYEE_NOT_FOUND: 'Colaborador não encontrado',
		NEW_PASSWORD_ERROR: 'Falha ao cadastrar senha',
		NEW_PASSWORD_SUCCESS: 'Senha cadastrada com sucesso',
		GET_BY_EMAIL_ERROR: 'Falha ao recuperar dados do usuário',
		COMPANY_CHANGE_SUCCESS: 'Empresa alterada com sucesso'
	}
};

export default MESSAGES;
